import { render } from "./LandingFooter.vue?vue&type=template&id=3515eff3"
import script from "./LandingFooter.vue?vue&type=script&lang=js"
export * from "./LandingFooter.vue?vue&type=script&lang=js"

import "./LandingFooter.vue?vue&type=style&index=0&id=3515eff3&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__